export const FETCH_ALL_LEVELS = 'FETCH_ALL_LEVELS';
export const CREATE_LEVEL = 'CREATE_LEVEL';
export const DELETE_LEVEL = 'DELETE_LEVEL';
export const PATCH_LEVEL = 'PATCH_LEVEL';